import { CustomerDocument } from 'src/pages/CaseDetails/interfaces/CaseDetail.type';

export interface IDownloadableDocuments {
  documents: CustomerDocument[];
}

export enum DOCUMENT_TYPES {
  SELFIE = 'SELFIE',
  AADHAR = 'AADHAR',
  aadhar_photo = 'aadhar_photo',
  VKYC_VIDEO = 'VKYC_VIDEO',
  PAN = 'PAN',
  LDN = 'LDN',
  LRN = 'LRN',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  LOAN_AGREEMENT = 'LOAN_AGREEMENT',
  LOAN_STATEMENT = 'LOAN_STATEMENT'
}

export enum ContentType {
  APPLICATION_PDF = 'application/pdf',
  IMAGE = 'image',
  PDF = 'pdf'
}

export enum LanguageType {
  ENGLISH = 'ENGLISH'
}

export const DOCUMENT_TYPE_TO_LABEL: { [key: string]: string } = {
  [DOCUMENT_TYPES.AADHAR]: 'Aadhar',
  [DOCUMENT_TYPES.LOAN_AGREEMENT]: 'Loan agreement',
  [DOCUMENT_TYPES.LOAN_STATEMENT]: 'Loan statement'
};
